import React from 'react';
import {connect} from 'react-redux';
import DialogContentText from '@material-ui/core/DialogContentText';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

import DVRSnapshotsStepper from '../container/DVRSnapshotsStepper';
import {closeSnapshotsCarousel} from '../DVRSnapshotsActions';

class DVRSnapshotsCarousel extends React.PureComponent {

  static defaultProps = {
    activeChannelName: null,
    snapshots: {
      channels: [
        {name: 'forwardFacing', image: null},
        {name: 'driver', image: null},
        {name: 'passenger', image: null},
        {name: 'rear', image: null}
      ]
    }
  }

  activeChannel = () => {
    const {channels} = this.props.snapshots;

    let idx = channels.findIndex(channel => channel.name === this.props.activeChannelName);
    if (idx < 0) {
      idx = 0;
    }
    return idx;
  }

  handleCloseSnapshotsCarousel = () => {
    this.props.closeSnapshotsCarousel();
  }

  render() {
    return (
      <div>
        <DialogContentText>
          <IconButton className="dvrcard__imgclose" onClick={this.handleCloseSnapshotsCarousel}>
            <Icon>close</Icon>
          </IconButton>

          <DVRSnapshotsStepper
            machineType={this.props.machineType}
            channels={this.props.snapshots.channels}
            activeChannel={this.activeChannel()}
          />
        </DialogContentText>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {dvrSnapshots} = state;
  return dvrSnapshots;
};

export default connect(mapStateToProps, {closeSnapshotsCarousel})(DVRSnapshotsCarousel);
